import { render, staticRenderFns } from "./ShipmentsForm.vue?vue&type=template&id=714cff44&"
import script from "./ShipmentsForm.vue?vue&type=script&lang=js&"
export * from "./ShipmentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports